<template>
  <div class="animate__animated cookie" :class="manimate">
    <div class="cookie-center">
      <p>
        We use cookies to enhance your experience. By continuing to visite this site, you agree to our
        <a href="https://support.movingkite.com/hc/en-us/articles/4408785752347" target="_blank">Privacy Policy</a>
      </p>
      <div class="btn" @click="agreeCookiePrivacy">
        <span>Got it</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveCookie',
  data() {
    return {
      manimate: 'animate__fadeInUp',
    };
  },
  methods: {
    agreeCookiePrivacy() {
      this.manimate = 'animate__fadeOutDown';
      setTimeout(() => {
        this.$store.commit('app/agreeCookiePrivacy');
      }, 600);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/main.less';
@import '../../assets/fonts/font.less';
.cookie {
  height: 100px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: @app-black-color;
  .cookie-center {
    width: 1044px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px auto;
    height: 100%;
    p {
      .font-regular;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      a {
        color: #fff;
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .btn {
      .font-light;
      width: 116px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 300;
      color: @app-black-color;
      line-height: 46px;
      text-align: center;
    }
  }
}
</style>
